import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import MyRoom_admin from './MyRoom_admin';
import './AdminLayout.scss';

const AdminLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="admin-layout">
            {/* ����� ��� ��� �� */}
            <div className="mobile-topbar">
                <button
                    className="btn-mobile-sidebar-toggle"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                >
                    {isSidebarOpen ? '?' : '?'}
                </button>
            </div>

            {/* ����� �������� */}
            {isSidebarOpen && (
                <div className="mobile-sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />
            )}

            <aside className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                <MyRoom_admin closeMobileMenu={() => setIsSidebarOpen(false)} />
            </aside>
            <main className="content">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
